import { createContext } from 'react'

export const IsInSideSheetContext = createContext(false)
